/* eslint-disable max-len */
import React from 'react';
import ModalFormComp from '../../../../components/ModalFormComp';
import StyledButton from '../../../../components/StyledButton';
import CommentIcon from '../../../../svgs/CommentIcon';
import './CommentModal.scss';

interface ICommentModal{
  comment?:string;
  closeModal?:any;
}
const CommentModal = ({ comment, closeModal }:ICommentModal) => (
  <div>
    <ModalFormComp removeTitle modalType="comment-modal" closeModal={closeModal}>
      <div style={{ textAlign: 'center' }}>
        <CommentIcon />
      </div>
      <div className="comment-title">Comment</div>
      <div className="comment-content">
        {comment}
      </div>
      <div style={{ marginTop: '24px' }}>
        {' '}
        <StyledButton name="Cancel" backgroundColor="#523B9F" width="100%" height="31px" borderRadius="4px" color="white" fontSize="12px" onClick={closeModal} />
      </div>
    </ModalFormComp>
  </div>
);
export default CommentModal;
